import { Component, Input, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrderStatusConstants } from 'src/app/core/constants/order-status-constants';
import { OrderFacade } from 'src/app/store/order/facade';

@Component({
  selector: 'app-refinement-of-parameters',
  templateUrl: './refinement-of-parameters.component.html',
  styleUrls: ['./refinement-of-parameters.component.scss'],
  standalone: false,
})
export class RefinementOfParametersComponent implements OnInit {
  translate = inject(TranslateService);
  private orderFacade = inject(OrderFacade);

  @Input() order;
  @Input() mark;

  description: string;

  ngOnInit(): void {}

  sendClarification() {
    this.orderFacade.saveStatus(
      this.order.id,
      this.mark,
      this.description,
      null,
      OrderStatusConstants.OrderStatuses.ParametersSpecified,
      false
    );
  }
}
